export default __webpack_public_path__ + "static/media/background-newletter.53b706f9.svg";